module.exports = __webpack_public_path__ + "img/eat_feet_red.3110229d.jpg";